import { useAdminEventController_findMembershipJournal } from '@api-client/generated/AdminEventController/findMembershipJournal';
import { Schemas } from '@api-client/generated/types';

type JournalEvent = Schemas.MembershipEventRecordDto;

export interface MembershipJournalFilters {
  /** Optional target member (entityId); omit for the full company feed. */
  entityId?: string;
  type?: Schemas.MembershipEventRecordDto['type'];
  dateFrom?: string;
  dateTo?: string;
  page?: number;
}

export interface UseMembershipJournalResult {
  events: JournalEvent[];
  metadata: Schemas.PaginationMetadata | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

const PER_PAGE = 25;

/**
 * Thin wrapper over the generated membership-journal query. Company-scoped (the
 * companyId travels as a header, handled by the client); works independently of
 * current membership rows, so revoked members' history stays discoverable.
 */
export const useMembershipJournal = (
  companyId: string,
  filters: MembershipJournalFilters = {}
): UseMembershipJournalResult => {
  const query = useAdminEventController_findMembershipJournal({
    params: {
      companyId,
      page: filters.page ?? 1,
      perPage: PER_PAGE,
      entityId: filters.entityId,
      type: filters.type,
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
    },
    config: { enabled: !!companyId },
  });

  const events: JournalEvent[] = query.data?.records ?? [];

  return {
    events,
    metadata: query.data?.metadata,
    isLoading: query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
};
